(function () {
  var DISMISS_COOKIE = 'sarron_nl_dismiss';
  var SUBSCRIBED_KEY = 'sarron_nl_subscribed';
  var DISMISS_COUNT_KEY = 'sarron_nl_dismiss_count';
  var SESSION_COUNT_KEY = 'sarron_nl_sessions';
  var PAGE_COUNT_KEY = 'sarron_nl_pages';
  var SUBSCRIBED_DAYS = 365;
  var MAX_DISMISSES = 3;
  var SCROLL_UP_THRESHOLD_MOBILE = 200;
  var SCROLL_UP_THRESHOLD_DESKTOP = 400;
  var MOBILE_BREAKPOINT = 768;
  var IDLE_MS = 25000;
  var SCROLL_DEPTH_MIN = 0.3;
  var FOOTER_MARGIN = '200px';
  var BEACON_URL = 'https://hub.sarron.in/api/beacon';

  var overlay = document.getElementById('nl-popup-overlay');
  if (!overlay) return;

  var DISMISS_DAYS = parseInt(overlay.getAttribute('data-dismiss-days') || '3', 10);
  var BASE_TIMER_MS = parseInt(overlay.getAttribute('data-timer-delay') || '40', 10) * 1000;
  var FALLBACK_ONLY = overlay.getAttribute('data-fallback-only') === '1';
  var FALLBACK_DELAY_MS = parseInt(overlay.getAttribute('data-fallback-delay') || '15', 10) * 1000;

  if (document.body.classList.contains('sarron-mode-wholesale')) return;
  if (overlay.dataset.nlInit) return;
  overlay.dataset.nlInit = '1';

  var PHONE_DATA = {
    IN:[91,10,10],US:[1,10,10],CA:[1,10,10],GB:[44,10,10],DE:[49,10,11],
    FR:[33,9,9],IT:[39,9,10],ES:[34,9,9],NL:[31,9,9],BE:[32,8,9],
    CH:[41,9,9],AT:[43,10,11],SE:[46,7,9],NO:[47,8,8],DK:[45,8,8],
    FI:[358,6,9],PT:[351,9,9],IE:[353,9,9],PL:[48,9,9],CZ:[420,9,9],
    HU:[36,8,9],RO:[40,9,9],BG:[359,8,9],HR:[385,8,9],GR:[30,10,10],
    CY:[357,8,8],MT:[356,8,8],LV:[371,8,8],LT:[370,8,8],EE:[372,7,8],
    SK:[421,9,9],SI:[386,8,8],LU:[352,6,9],AE:[971,9,9],SA:[966,9,9],
    SG:[65,8,8],AU:[61,9,9],NZ:[64,8,10],JP:[81,10,10],KR:[82,9,10],
    QA:[974,8,8],KW:[965,8,8],BH:[973,8,8],OM:[968,8,8],MY:[60,9,10],
    TH:[66,9,9],ID:[62,9,12],PH:[63,10,10],BD:[880,10,10],LK:[94,9,9],
    NP:[977,10,10],PK:[92,10,10],ZA:[27,9,9],NG:[234,10,10],KE:[254,9,9],
    BR:[55,10,11],MX:[52,10,10],AR:[54,10,10],CL:[56,9,9],CO:[57,10,10]
  };
  var DEFAULT_PHONE = [null, 6, 15];

  var shopifyCountry = overlay.getAttribute('data-country') || (window.Shopify && window.Shopify.country) || '';
  var phoneInfo = PHONE_DATA[shopifyCountry] || DEFAULT_PHONE;
  var dialCode = phoneInfo[0];
  var phoneMinDigits = phoneInfo[1];
  var phoneMaxDigits = phoneInfo[2];

  var prefixEl = document.getElementById('nl-phone-prefix');
  var phoneField = document.getElementById('nl-phone');
  if (prefixEl && dialCode !== null) {
    prefixEl.textContent = '+' + dialCode;
  } else if (prefixEl) {
    prefixEl.textContent = '+';
  }
  if (phoneField) {
    phoneField.maxLength = phoneMaxDigits;
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() +
      ';path=/;domain=.sarron.in;Secure;SameSite=Lax';
  }

  function store(key, value) {
    setCookie(key, value, SUBSCRIBED_DAYS);
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  function retrieve(key) {
    var v = getCookie(key);
    if (v) return v;
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function storeSession(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  }

  function retrieveSession(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function sendBeaconEvent(payload) {
    var body = JSON.stringify({ events: [payload] });
    try {
      var sent = navigator.sendBeacon && navigator.sendBeacon(BEACON_URL, new Blob([body], { type: 'text/plain' }));
      if (!sent) {
        fetch(BEACON_URL, { method: 'POST', body: body, keepalive: true, credentials: 'omit' });
      }
    } catch (e) {}
  }

  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event, nl_session: sessionCount, nl_page: pageCount, nl_device: isMobile ? 'mobile' : 'desktop' };
    // Stamp the trigger on every popup event after impression so downstream
    // funnel queries can attribute submit/success back to the trigger source
    // (e.g. onetap_fallback). triggerSource is set inside showPopup().
    if (triggered && triggerSource && triggerSource !== 'unknown') payload.nl_trigger = triggerSource;
    if (data) {
      for (var k in data) {
        if (data.hasOwnProperty(k)) payload[k] = data[k];
      }
    }
    window.dataLayer.push(payload);
    var evt = {};
    for (var j in payload) {
      if (payload.hasOwnProperty(j)) evt[j] = payload[j];
    }
    evt.page_url = location.pathname;
    sendBeaconEvent(evt);
  }

  if (retrieve(SUBSCRIBED_KEY)) return;
  if (retrieve(DISMISS_COOKIE)) return;

  var dismissCount = parseInt(retrieve(DISMISS_COUNT_KEY) || '0', 10);
  if (dismissCount >= MAX_DISMISSES) return;

  var sessionCount = parseInt(retrieve(SESSION_COUNT_KEY) || '0', 10);
  if (!retrieveSession('sarron_nl_seen')) {
    sessionCount++;
    store(SESSION_COUNT_KEY, String(sessionCount));
    storeSession('sarron_nl_seen', '1');
  }

  var pageCount = parseInt(retrieveSession(PAGE_COUNT_KEY) || '0', 10) + 1;
  storeSession(PAGE_COUNT_KEY, String(pageCount));

  var timerMs;
  if (sessionCount >= 3 || pageCount >= 3) {
    timerMs = Math.round(BASE_TIMER_MS * 0.375);
  } else if (sessionCount >= 2) {
    timerMs = Math.round(BASE_TIMER_MS * 0.625);
  } else {
    timerMs = BASE_TIMER_MS;
  }

  var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  var triggered = false;
  var pendingShow = false;
  var triggerSource = 'unknown';

  function getFocusable() {
    return overlay.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), a[href], [tabindex]:not([tabindex="-1"])');
  }

  function showPopup() {
    if (triggered) return;
    if (document.visibilityState === 'hidden') {
      pendingShow = true;
      return;
    }
    triggered = true;
    pendingShow = false;
    teardownTriggers();
    overlay.style.display = 'flex';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    });
    document.documentElement.style.overflow = 'hidden';
    var focusable = getFocusable();
    if (focusable.length) focusable[0].focus({ preventScroll: true });
    track('nl_popup_impression', { nl_trigger: triggerSource });
  }

  function hidePopup() {
    overlay.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      overlay.style.display = 'none';
    }, 300);
  }

  function dismiss() {
    dismissCount++;
    store(DISMISS_COUNT_KEY, String(dismissCount));
    if (dismissCount >= MAX_DISMISSES) {
      store(DISMISS_COOKIE, '1');
    } else {
      setCookie(DISMISS_COOKIE, '1', DISMISS_DAYS);
    }
    track('nl_popup_dismiss', { nl_dismiss_count: dismissCount });
    hidePopup();
  }

  function markSubscribed() {
    store(SUBSCRIBED_KEY, '1');
  }

  function goToStep(n) {
    var steps = overlay.querySelectorAll('[data-nl-step]');
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('nl-step--active');
    }
    var target = overlay.querySelector('[data-nl-step="' + n + '"]');
    if (target) {
      target.classList.add('nl-step--active');
      var firstInput = target.querySelector('input:not([type="hidden"]):not([tabindex="-1"])');
      if (firstInput && isMobile) {
        setTimeout(function () { firstInput.focus(); }, 1000);
      } else if (firstInput) {
        firstInput.focus({ preventScroll: true });
      }
    }
  }

  overlay.querySelector('.nl-close').addEventListener('click', dismiss);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) dismiss();
  });

  document.addEventListener('keydown', function (e) {
    if (overlay.style.display !== 'flex') return;
    if (e.key === 'Escape') {
      dismiss();
      return;
    }
    if (e.key === 'Tab') {
      var focusable = getFocusable();
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });

  var nextBtn = overlay.querySelector('[data-nl-next]');
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      var step = this.getAttribute('data-nl-next');
      track('nl_popup_step', { nl_step: step });
      goToStep(step);
    });
  }

  overlay.querySelector('[data-nl-dismiss]').addEventListener('click', dismiss);

  var confirmBtns = overlay.querySelectorAll('[data-nl-confirm]');
  for (var i = 0; i < confirmBtns.length; i++) {
    confirmBtns[i].addEventListener('click', function () {
      hidePopup();
    });
  }

  var marketingCheckbox = document.getElementById('nl-marketing-checkbox');
  var marketingHidden = document.getElementById('nl-marketing-hidden');
  if (marketingCheckbox && marketingHidden) {
    marketingCheckbox.addEventListener('change', function () {
      marketingHidden.value = this.checked ? 'true' : 'false';
    });
  }

  var phoneInput = document.getElementById('nl-phone');
  var phoneHidden = document.getElementById('nl-phone-hidden');
  if (phoneInput && phoneHidden) {
    phoneInput.addEventListener('input', function () {
      var digits = this.value.replace(/\D/g, '');
      this.value = digits;
      phoneHidden.value = digits ? '+' + (dialCode !== null ? dialCode : '') + digits : '';
      if (digits.length === 0 || (digits.length >= phoneMinDigits && digits.length <= phoneMaxDigits)) clearFieldError(this);
    });
  }

  var emailInputForClear = document.getElementById('nl-email');
  if (emailInputForClear) {
    emailInputForClear.addEventListener('input', function () {
      var v = this.value.trim();
      if (v && EMAIL_RE.test(v)) {
        clearFieldError(this);
        clearTypoSuggestion(this);
      }
    });
  }

  var form = document.getElementById('nl-popup-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    });

    var fieldOrder = ['nl-first-name', 'nl-email', 'nl-phone'];
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var idx = fieldOrder.indexOf(e.target.id);
      if (idx === -1) return;
      e.preventDefault();
      if (idx < fieldOrder.length - 1) {
        var next = document.getElementById(fieldOrder[idx + 1]);
        if (next) next.focus();
      } else {
        handleSubmit();
      }
    });
  }

  function showFieldError(input, message) {
    input.classList.add('nl-input--error');
    var wrapper = input.closest('.nl-field');
    if (!wrapper) return;
    var existing = wrapper.querySelector('.nl-field-error');
    if (existing) {
      existing.textContent = message;
      existing.style.display = 'block';
      return;
    }
    var msg = document.createElement('span');
    msg.className = 'nl-field-error';
    msg.textContent = message;
    wrapper.appendChild(msg);
  }

  function clearFieldError(input) {
    input.classList.remove('nl-input--error');
    var wrapper = input.closest('.nl-field');
    if (!wrapper) return;
    var existing = wrapper.querySelector('.nl-field-error');
    if (existing) existing.style.display = 'none';
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  var DOMAIN_TYPOS = {
    'gamil.com':'gmail.com','gmial.com':'gmail.com','gmai.com':'gmail.com',
    'gnail.com':'gmail.com','gmaill.com':'gmail.com','gmil.com':'gmail.com',
    'gmal.com':'gmail.com','gmali.com':'gmail.com','gmail.co':'gmail.com',
    'yaho.com':'yahoo.com','yahooo.com':'yahoo.com','yhaoo.com':'yahoo.com',
    'yahoo.co':'yahoo.com',
    'hotmial.com':'hotmail.com','hotmal.com':'hotmail.com','hotmil.com':'hotmail.com',
    'hotmail.co':'hotmail.com',
    'outlok.com':'outlook.com','outloo.com':'outlook.com','outlookcom':'outlook.com',
    'outlook.co':'outlook.com',
    'iclod.com':'icloud.com','icloud.co':'icloud.com',
    'protonmal.com':'protonmail.com','protonmail.co':'protonmail.com',
    'rediffmal.com':'rediffmail.com','rediffmail.co':'rediffmail.com'
  };

  function checkEmailTypo(email) {
    var parts = email.toLowerCase().split('@');
    if (parts.length !== 2) return null;
    var domain = parts[1];
    return DOMAIN_TYPOS[domain] ? parts[0] + '@' + DOMAIN_TYPOS[domain] : null;
  }

  var pendingSuggestion = null;

  function showTypoSuggestion(input, suggested) {
    var wrapper = input.closest('.nl-field');
    if (!wrapper) return;
    var existing = wrapper.querySelector('.nl-field-suggest');
    if (existing) existing.remove();
    var el = document.createElement('span');
    el.className = 'nl-field-suggest';
    el.appendChild(document.createTextNode('Did you mean '));
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nl-suggest-btn';
    btn.textContent = suggested;
    el.appendChild(btn);
    el.appendChild(document.createTextNode('?'));
    wrapper.appendChild(el);
    btn.addEventListener('click', function () {
      input.value = suggested;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      el.remove();
      pendingSuggestion = null;
      clearFieldError(input);
    });
  }

  function clearTypoSuggestion(input) {
    var wrapper = input.closest('.nl-field');
    if (!wrapper) return;
    var existing = wrapper.querySelector('.nl-field-suggest');
    if (existing) existing.remove();
    pendingSuggestion = null;
  }

  function handleSubmit() {
    var hpField = document.getElementById('nl-hp');
    if (hpField && hpField.value) {
      markSubscribed();
      track('nl_popup_bot');
      goToStep(3);
      return;
    }

    var emailInput = document.getElementById('nl-email');
    var phoneInputEl = document.getElementById('nl-phone');
    var hasError = false;

    clearFieldError(emailInput);
    if (phoneInputEl) clearFieldError(phoneInputEl);

    var emailVal = emailInput.value.trim();

    if (!emailVal) {
      showFieldError(emailInput, 'Please enter your email address');
      emailInput.focus();
      hasError = true;
    } else if (!EMAIL_RE.test(emailVal)) {
      showFieldError(emailInput, 'Please enter a valid email address');
      emailInput.focus();
      hasError = true;
    } else {
      var suggestion = checkEmailTypo(emailVal);
      if (suggestion && suggestion !== pendingSuggestion) {
        pendingSuggestion = suggestion;
        showTypoSuggestion(emailInput, suggestion);
        hasError = true;
      }
    }

    if (phoneInputEl && phoneInputEl.value.length > 0) {
      var len = phoneInputEl.value.length;
      if (len < phoneMinDigits || len > phoneMaxDigits) {
        var article = (phoneMinDigits === 8 || phoneMinDigits === 11 || phoneMinDigits === 18) ? 'an ' : 'a ';
        var msg = phoneMinDigits === phoneMaxDigits
          ? 'Please enter ' + article + phoneMinDigits + '-digit phone number'
          : 'Please enter ' + phoneMinDigits + '-' + phoneMaxDigits + ' digits';
        showFieldError(phoneInputEl, msg);
        if (!hasError) phoneInputEl.focus();
        hasError = true;
      }
    }

    if (hasError) return;

    var submitBtn = document.getElementById('nl-submit-btn');
    var btnText = submitBtn.querySelector('.nl-btn__text');
    var btnSpinner = submitBtn.querySelector('.nl-btn__spinner');
    submitBtn.disabled = true;
    btnText.style.display = 'none';
    btnSpinner.style.display = '';

    var existingError = form.querySelector('.nl-error');
    if (existingError) existingError.style.display = 'none';

    track('nl_popup_submit');

    var formData = new FormData(form);
    formData.delete('company_name');

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.text().then(function (html) {
          return { ok: response.ok, status: response.status, html: html };
        });
      })
      .then(function (result) {
        if (result.ok) {
          if (result.html.length < 10 || result.html.indexOf('Verifying') !== -1 || result.html.indexOf('challenge') !== -1) {
            throw new Error('blocked');
          }
          markSubscribed();
          track('nl_popup_success');
          goToStep(3);
          return;
        }

        var isAlreadyTaken =
          result.html.indexOf('has already been taken') !== -1 ||
          result.html.indexOf('email has already') !== -1;

        if (isAlreadyTaken) {
          markSubscribed();
          track('nl_popup_already_subscribed');
          goToStep(4);
          return;
        }

        throw new Error('submit failed');
      })
      .catch(function (err) {
        var errorDiv = form.querySelector('.nl-error');
        if (!errorDiv) {
          errorDiv = document.createElement('div');
          errorDiv.className = 'nl-error';
          form.insertBefore(errorDiv, form.firstChild);
        }
        errorDiv.textContent = 'Something went wrong. Please try again.';
        errorDiv.style.display = 'block';
        track('nl_popup_error');

        submitBtn.disabled = false;
        btnText.style.display = '';
        btnSpinner.style.display = 'none';
      });
  }

  var submitBtn = document.getElementById('nl-submit-btn');
  if (submitBtn) {
    submitBtn.addEventListener('click', handleSubmit);
  }

  if (isMobile && window.visualViewport) {
    var popup = overlay.querySelector('.nl-popup');
    window.visualViewport.addEventListener('resize', function () {
      if (overlay.style.display !== 'flex') return;
      var keyboardHeight = window.innerHeight - window.visualViewport.height;
      popup.style.marginBottom = keyboardHeight > 50 ? keyboardHeight + 'px' : '0';
    });
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && overlay.style.display !== 'flex') {
      document.documentElement.style.overflow = '';
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && pendingShow) {
      showPopup();
    }
  });

  var cleanups = [];

  function addTrigger(setup) {
    var cleanup = setup();
    if (cleanup) cleanups.push(cleanup);
  }

  function teardownTriggers() {
    for (var i = 0; i < cleanups.length; i++) {
      cleanups[i]();
    }
    cleanups = [];
  }

  if (FALLBACK_ONLY) {
    window.addEventListener('sarron:onetap-fallback', function () {
      setTimeout(function () {
        triggerSource = 'onetap_fallback';
        showPopup();
      }, FALLBACK_DELAY_MS);
    });
    return;
  }

  addTrigger(function () {
    var id = setTimeout(function () {
      triggerSource = 'timer';
      showPopup();
    }, timerMs);
    return function () { clearTimeout(id); };
  });

  if (!isMobile) {
    addTrigger(function () {
      function onMouseOut(e) {
        if (e.clientY <= 0 && e.relatedTarget == null) {
          triggerSource = 'mouse_leave';
          showPopup();
        }
      }
      document.addEventListener('mouseout', onMouseOut, { passive: true });
      return function () { document.removeEventListener('mouseout', onMouseOut); };
    });

    addTrigger(function () {
      var minTime = 5000;
      var loaded = Date.now();
      function onBlur() {
        if (Date.now() - loaded > minTime) {
          triggerSource = 'window_blur';
          showPopup();
        }
      }
      window.addEventListener('blur', onBlur);
      return function () { window.removeEventListener('blur', onBlur); };
    });
  }

  addTrigger(function () {
    var minTime = 8000;
    var loaded = Date.now();
    function onVisChange() {
      if (document.visibilityState === 'hidden' && Date.now() - loaded > minTime) {
        triggerSource = 'tab_switch';
        showPopup();
      }
    }
    document.addEventListener('visibilitychange', onVisChange);
    return function () { document.removeEventListener('visibilitychange', onVisChange); };
  });

  addTrigger(function () {
    var threshold = isMobile ? SCROLL_UP_THRESHOLD_MOBILE : SCROLL_UP_THRESHOLD_DESKTOP;
    var maxDepthReached = 0;
    var lastScrollY = window.scrollY;
    var upDistance = 0;
    var ticking = false;

    function check() {
      var currentY = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var depthRatio = docHeight > 0 ? currentY / docHeight : 0;

      if (depthRatio > maxDepthReached) maxDepthReached = depthRatio;

      if (maxDepthReached >= SCROLL_DEPTH_MIN) {
        if (currentY < lastScrollY) {
          upDistance += lastScrollY - currentY;
        } else {
          upDistance = 0;
        }
        if (upDistance >= threshold) {
          triggerSource = 'scroll_up';
          showPopup();
        }
      }

      lastScrollY = currentY;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(check);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    return function () { window.removeEventListener('scroll', onScroll); };
  });

  if (isMobile && 'IntersectionObserver' in window) {
    addTrigger(function () {
      var footer = document.querySelector('footer') ||
                   document.querySelector('[class*="footer"]') ||
                   document.querySelector('.footer-group');
      if (!footer) return null;

      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          triggerSource = 'footer_reached';
          showPopup();
        }
      }, { rootMargin: FOOTER_MARGIN });

      observer.observe(footer);
      return function () { observer.disconnect(); };
    });
  }

  if (isMobile) {
    addTrigger(function () {
      var idleTimer = null;
      var engaged = false;

      function onActivity() {
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var depthRatio = docHeight > 0 ? window.scrollY / docHeight : 0;
        if (depthRatio >= 0.4) engaged = true;

        if (engaged) {
          clearTimeout(idleTimer);
          idleTimer = setTimeout(function () {
            triggerSource = 'touch_idle';
            showPopup();
          }, IDLE_MS);
        }
      }

      document.addEventListener('scroll', onActivity, { passive: true });
      document.addEventListener('touchstart', onActivity, { passive: true });
      return function () {
        clearTimeout(idleTimer);
        document.removeEventListener('scroll', onActivity);
        document.removeEventListener('touchstart', onActivity);
      };
    });
  }

})();
